const tooltipContent = {
  fox: 'partners-widgets.advertiser-disclaimer.fox',
  thebalance1: 'partners-widgets.advertiser-disclaimer.default',
  investopedia1: 'partners-widgets.advertiser-disclaimer.default',
}

export { tooltipContent }
